import { Component, OnInit } from '@angular/core';
import { AnnouncementsService, Announcement } from '../../../lib/announcements.service';
import { ModalService } from '../../../lib/modal.service';
import { LogService } from '../../../lib/log.service';
import { AnnouncementEditComponent } from './announcement-edit/announcement-edit.component';
import { User } from 'app/models/user';
import { Organization } from 'app/models/organization';
import { UserService } from 'app/lib/user.service';
import { ApiService } from 'app/lib/api.service';

@Component({
    selector: 'app-announcements',
    templateUrl: './announcements.component.html',
    styleUrls: ['./announcements.component.scss'],
    standalone: false
})
export class AnnouncementsComponent implements OnInit {
  activeAnnouncements: Announcement[] = [];
  expiredAnnouncements: Announcement[] = [];
  isLoading = true;
  organizations: Organization[];
  user: User;

  constructor(
    private announcementsService: AnnouncementsService,
    private modalService: ModalService,
    private logService: LogService,
    private api: ApiService,
    private userService: UserService,
  ) {
    this.user = this.userService.getUser();
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.loadAnnouncements();
    if (this.user.userType === "superadmin" ) {
      // todo: get orgs with service type 
      this.api.get("admin/organizations", { Active: true }).subscribe(
          (results: any) => {
              this.organizations = Organization.initializeArray(results.data);
              this.isLoading = false;
          },
          (error: any) => {
              this.logService.error("Error loading. " + error.message);
              this.isLoading = false;
          }
      ); 
  }
  }

  loadAnnouncements(): void {
    this.isLoading = true;
    this.announcementsService.getAnnouncements().subscribe(
      (announcementsData) => {
        const announcementData = announcementsData;
        this.activeAnnouncements = announcementData.active_announcements;
        this.expiredAnnouncements = announcementData.expired_announcements;
        this.isLoading = false;
      },
      (error) => {
        this.logService.error(`Error loading announcements: ${error}`);
        this.isLoading = false;
        this.modalService.showAlert('Error', 'Failed to load announcements');
      }
    );
  }

  doCreate(): void {
    this.modalService.setCloseOnClickAway(false);
    this.modalService.showComponent(AnnouncementEditComponent, { organizations: this.organizations }).afterClosed().subscribe(result => {
      if (result) {
        this.loadAnnouncements();
      }
    });
  }

  editAnnouncement(announcement: Announcement): void {
    this.modalService.setCloseOnClickAway(false);
    const modal = this.modalService.showComponent(AnnouncementEditComponent, { announcementId: announcement.ID, organizations: this.organizations, isEditing: true });
    modal.afterClosed().subscribe(result => {
      if (result) {
        this.loadAnnouncements();
      }
    });
  }

  deleteAnnouncement(announcement: Announcement): void {
    if (announcement.ID) {
      this.modalService.showConfirmation(
        'Delete Announcement',
        'Are you sure you want to delete this announcement?'
      ).afterClosed().subscribe((result) => {
        if (result) {
          this.announcementsService.deleteAnnouncement(announcement.ID).subscribe(
            () => {
              this.loadAnnouncements();
              this.modalService.showAlert('Success', 'Announcement deleted successfully');
            },
            (error) => {
              this.logService.error(`Error deleting announcement: ${error}`);
              this.modalService.showAlert('Error', 'Failed to delete announcement');
            }
          );
        }
      });
    }
  }

  viewAnnouncement(announcement: Announcement): void {
    this.modalService.setCloseOnClickAway(false);
    const modal = this.modalService.showComponent(AnnouncementEditComponent, { announcementId: announcement.ID, organizations: this.organizations });
    modal.afterClosed().subscribe(result => {
      if (result) {
        this.loadAnnouncements();
      }
    });
  }

  endAnnouncement(announcement: Announcement): void {
    this.modalService.setCloseOnClickAway(false);
    const announcementData = {
      ...announcement,
      EndDate: new Date(),
      forceEnd: true
    };

    this.announcementsService.updateAnnouncement(announcement.ID, announcementData).subscribe(
      (response) => {
        this.loadAnnouncements();
        this.modalService.showAlert('Success', 'Announcement ended successfully');
      },
      (error) => {
        this.logService.error(`Error ending announcement: ${error}`);
        this.modalService.showAlert('Error', 'Failed to end announcement');
      }
    );
  }
} 